module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro2.1f21b8c5.mp3";